import { createAction, createAsyncAction } from 'typesafe-actions';
import {
  RevalueTradesMetricsRequestPayload,
  RevalueTradesMetricsSuccessPayload,
  TaskProgressSuccessPayload,
} from '../types';

export type GetTaskProgressRequestPayload = {
  task_id: string;
};
export type GetTaskProgressSuccessPayload = {
  data: TaskProgressSuccessPayload;
};

export const getValueTaskProgress = createAsyncAction(
  'tradeCenter/getValueTaskProgress/request',
  'tradeCenter/getValueTaskProgress/success',
  'tradeCenter/getValueTaskProgress/failure',
)<
  GetTaskProgressRequestPayload,
  GetTaskProgressSuccessPayload,
  GetTaskProgressRequestPayload
>();

export const getCVATaskProgress = createAsyncAction(
  'tradeCenter/getCVATaskProgress/request',
  'tradeCenter/getCVATaskProgress/success',
  'tradeCenter/getCVATaskProgress/failure',
)<
  GetTaskProgressRequestPayload,
  GetTaskProgressSuccessPayload,
  GetTaskProgressRequestPayload
>();

export type GetRevaluationSuccessPayload = {
  data: RevalueTradesMetricsSuccessPayload;
};

export const revalueTrades = createAsyncAction(
  'tradeCenter/revalueTrades/request',
  'tradeCenter/revalueTrades/success',
  'tradeCenter/revalueTrades/failure',
)<
  RevalueTradesMetricsRequestPayload,
  GetRevaluationSuccessPayload,
  undefined
>();

export const revalueCVA = createAsyncAction(
  'tradeCenter/revalueCVA/request',
  'tradeCenter/revalueCVA/success',
  'tradeCenter/revalueCVA/failure',
)<
  RevalueTradesMetricsRequestPayload,
  GetRevaluationSuccessPayload,
  undefined
>();

export const reset = createAction('tradeCenter/reset')();
